import React from 'react';
import _omit from 'lodash/omit';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import Typography from 'components/Typography';
import { NOKIA_PURE_TEXT_BOLD } from '@nokia-csf-uxr/freeform-design-tokens/tokens/fontFamily';

const CHARACTER_COUNT_TYPOGRAPHY_CONFIG = {
  variant: 'CAPTION' as const,
  maxLines: 1,
};

export interface TextAreaCharacterCountProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the component. e.g 10 / 20 */
  children: string;
  /** To customize the wrapper style. */
  style?: React.CSSProperties
}

/** Any other props than the `TextAreaCharacterCount` props will be provided to the <Typography /> component. */
const TextAreaCharacterCount = React.forwardRef<HTMLElement, TextAreaCharacterCountProps>((props: TextAreaCharacterCountProps, ref) => getContext(({ theme, RTL }) => {
  const {
    children,
    style,
    ...otherProps
  } = props;

  const CHARACTER_COUNT_TYPOGRAPHY_STYLE = {
    fontFamily: NOKIA_PURE_TEXT_BOLD,
    selfAlign: 'flex-end',
    textAlign: 'end',
    flex: '0 0 auto'
  };

  const COLOR_STYLE = {
    color: theme.TEXT_AREA.LABEL
  };
  const resolvedStyle = _merge({}, CHARACTER_COUNT_TYPOGRAPHY_STYLE, COLOR_STYLE, RTL ? { marginRight: '1rem' } : { marginLeft: '1rem' }, style);

  return (
    <Typography ref={ref} style={resolvedStyle} {..._omit({ ...CHARACTER_COUNT_TYPOGRAPHY_CONFIG, ...otherProps }, 'children')}>{props.children}</Typography>
  );
}));

TextAreaCharacterCount.defaultProps = {
  style: {}
};

TextAreaCharacterCount.displayName = 'TextAreaCharacterCount';
export default TextAreaCharacterCount;
